import { useEffect } from "react";
import masterpiece from "../assets/masterpiece.png";
import dbLogo from "../assets/db_logo.png";
import giftLogo from "../assets/gift_istanbul_logo.png";
import ivkLogo from "../assets/ivk_logo.png";

const AV = (v) => ({ "--p": `var(--img-${v})` });

const RAIL = [
  { period: "SABAH · 09:30 – 13:10" },
  { cls: "break", time: "09:30 – 10:00", topic: "Karşılama ve ikram", who: { text: "Kayıt masası ve açılış kahvesi" } },
  { time: "10:00 – 10:20", topic: "Hoş geldiniz", who: { img: "derya", name: "Derya Babuç Aydın", title: "DB Positive Kurucu" } },
  { time: "10:20 – 10:50", topic: "Finansal özgürlük", who: { img: "sinem", name: "Sinem Karabaşak Toplan", title: "Kurumsal Finans Stratejisti, Finansal Yönetim Danışmanı, Eğitmen" } },
  { cls: "keynote", time: "11:00 – 11:40", topic: "Hikâyenin kahramanı kim?", who: { img: "ozlem", name: "Özlem Köker Özdemir", title: "Eğitmen · Kurumsalhane: Umut Oğuz & Tuna Arman ve Genç Oyuncular" } },
  { cls: "break", time: "11:40 – 12:00", topic: "Ara · Networking", who: { text: "Canlı müzik, dijital deneyim aktiviteleri ve sürpriz etkinlikler" } },
  { cls: "keynote", time: "12:00 – 12:30", topic: "Agentic orkestrasyonda olmak ya da olmamak: yetkinlik, inisiyatif, sorumluluk", who: { img: "sebnem", name: "Doç. Dr. Şebnem Özdemir", title: "Yapay Zekâ Uzmanı, Akademisyen, Girişimci, Yazar" } },
  { time: "12:40 – 13:10", topic: "Dijital liderlik", who: { img: "yaprak", name: "Yaprak Yapsan", title: "Idecon Grup İletişim A.Ş. Yönetim Kurulu Başkanı" } },
  { period: "ÖĞLEDEN SONRA · 13:10 – 16:30" },
  { cls: "tbd", time: "13:10 – 13:40", topic: "Başka bir dünya mümkün", who: { text: "Daha sonra açıklanacak" } },
  { cls: "break", time: "13:40 – 14:00", topic: "Ara · Networking", who: { text: "Canlı müzik, dijital deneyim aktiviteleri ve sürpriz etkinlikler" } },
  { time: "14:00 – 14:30", topic: "Uygarlık sandalı battı", who: { img: "mine-ataman", name: "Mine Ataman", title: "Tarım Yazarı / Stratejist" } },
  { time: "14:40 – 15:10", topic: "Hayat bir maraton, peki nereye koşuyoruz?", who: { img: "mine-rana", name: "Mine Rana Kahramanoğlu", title: "Avukat, Arabulucu, İnsan Hakları Savunucusu, Konuşmacı, Yazar, Maraton Koşucusu" } },
  { time: "15:20 – 15:50", topic: "Sıfır atıktan ilham ve sanat", who: { img: "davoud", name: "Seyed Davoud", title: "Ressam, Yazar" } },
  { time: "15:50 – 16:00", topic: "Günün özeti ve kapanış", who: { text: "Kapanış konuşması" } },
  { cls: "break", time: "16:00 – 16:30", topic: "Happy hour", who: { text: "Canlı müzik, dijital deneyim aktiviteleri ve sürpriz etkinlikler" } },
];

const SPEAKERS = [
  {
    key: "sebnem", img: "sebnem", feature: true, name: "Doç. Dr. Şebnem Özdemir",
    role: "YAPAY ZEKÂ UZMANI · AKADEMİSYEN · YAZAR",
    bio: "Yıldız Teknik Üniversitesi Matematik lisansının ardından İstanbul Üniversitesi’nde Matematik Eğitimi ve Enformatik alanlarında iki yüksek lisans ve Enformatik doktorası yaptı. Doktora sonrası araştırmalarını Worcester Politeknik Enstitüsü’nde (WPI), 2019’da MIT Bilgisayar Bilimi ve Yapay Zekâ Laboratuvarı’nda (CSAIL) araştırma işbirlikçisi olarak sürdürdü.",
    more: "2016’da geliştirdiği makine öğrenmesi modeliyle Koç Üniversitesi UNESCO Kürsüsü’nün “İnsan Gelişimi Araştırmaları Ödülü”ne layık görüldü. Ekibiyle birlikte “Deep Project” serisi derin öğrenme uygulamalarını yürütüyor; Türk–Osmanlı sanatına odaklanan Deep Classical Art Projesi yurt içinde ve yurt dışında ilgiyle karşılandı.",
  },
  {
    key: "derya", img: "derya", pos: "center 30%", name: "Derya Babuç Aydın",
    role: "DB POSITIVE KURUCU · AÇILIŞ KONUŞMASI",
    bio: "1977 yılında İstanbul’da doğdu. İlk ve orta öğrenimini İstanbul, lise öğrenimini Bursa’da tamamladı. Marmara Üniversitesi, İktisadi ve İdari Bölümler Fakültesi İşletme bölümünden 1998 yılında mezuniyeti sonrası Derya Babuç Aydın, İstanbul Üniversitesi İşletme Enstitüsü Uluslararası İşletme Sertifika Programına devam etmiştir.",
    more: "İş hayatına Yaşar Holding Pınar Tüketim Malları Pazarlama Key Account Satış Yönetmeni olarak başlayan Derya Babuç Aydın, Migros’lardan sorumlu olarak bir yıl bünyede çalıştıktan sonra; Masters Training International’a kurumsal eğitimlerden sorumlu Satış Yönetmeni olarak geçmiştir. Eylül 2000’de kurumsal eğitimler satış ile başlayan çalışma sürecine 2002-2005 yılları arasında iletişim, ekip, yönetim eğitimlerinde yardımcı eğitmenlikle devam etmiştir. 2005’ten itibaren Masters ve Masters&Mountrain işbirliği ile yürütülen açık hava ve aktivite destekli iletişim ve ekip çalışmalarında eğitmenlik görevini de yürüten Derya Babuç Aydın; 2007-2009 yılları arasında Masters Training International’da Satış Müdürü, 2009-2010 yıllarında ise Proje ve İş Geliştirme Müdürü olarak çalışmıştır. 2010 Haziran ayında DB Positive Yaratıcı Çözümler ve Proje Yönetimi’ni kuran Derya Babuç Aydın; yöneticilik rolünün yanı sıra; kişisel gelişim ve beceri geliştirme alanlarında eğitimler vermekte, İlham Veren Konuşmalar kapsamında paylaşımlar gerçekleştirmektedir. 2020 yılı itibarı ile db-dizayn.com ve Gift İstanbul markaları ile kişiye ve kuruma özel hediyeler sektörüne de giriş yapan DB Positive bünyesinde Derya Babuç Aydın, iş geliştirme projelerini de yönetmektedir. Kendisini yemeği, içmeyi, eğlenmeyi, gezmeyi, seyahati, yeni yerler keşfetmeyi, insanları bir araya getiren organizasyonlar düzenlemeyi seven biri olarak tanımlayan Derya Babuç Aydın, spor salonunda ağırlık çalışmanın, sahilde uzun yürüyüşler yapmanın ve 1500 parçalık puzzle’ların stres ile başa çıkmada etkili yollar olduğunu iddia etmektedir.",
  },
  {
    key: "sinem", img: "sinem", name: "Sinem Karabaşak Toplan",
    role: "KURUMSAL FİNANS STRATEJİSTİ · DANIŞMAN · EĞİTMEN",
    bio: "Uludağ Üniversitesi İktisat mezunu. 25 yılı aşkın süredir bankacılık, kredi tahsis, kurumsal finansman ve mali işler alanlarında çalışan bir iktisatçı; finansı hem krediyi veren bankanın hem de finansman kullanan şirketin gözünden deneyimledi.",
    more: "Anadolubank’ta şube müdürlüğü, Pamukbank’ta kredi tahsis yöneticiliği, Pakipek Tekstil’de mali işler müdürlüğü yaptı. Kurucusu olduğu Finans Kontrol Merkezi’nde holdinglere ve büyük ölçekli şirketlere finansal yönetim, borç yapılandırma, yatırım finansmanı ve EBRD destekli proje süreçlerinde danışmanlık ve kurumsal eğitimler veriyor. Bizglobaliz’in kurucu ve yönetim kurulu başkanı, BTSO 55. Komite üyesi, TÜBİTAK BİGG+ ve TEKNOFEST T3 Vakfı mentörü. “paraninkralicesi” hesabıyla 250 bin takipçi ve 300 milyon izlenmeye ulaştı; 13 yıl Ekometre Gazetesi’nde köşe yazarlığı, OLAY TV “Finansa Bakış” programının hazırlıcılığı ve sunuculuğunu yaptı.",
  },
  {
    key: "ozlem", img: "ozlem", name: "Özlem Köker Özdemir",
    role: "EĞİTMEN · İNSAN KAYNAKLARI",
    bio: "İstanbul Üniversitesi Gazetecilik, Reklam ve Halkla İlişkiler mezunu; Marmara Üniversitesi’nde İşletme yüksek lisansı (MBA) ve Boğaziçi’nde Metro Grup Yönetim Akademisi’nde perakende yönetimi eğitimi aldı.",
    more: "Favori Kuyumculuk, Toyotasa, Doğan Holding, OYPA ve Metro Grup Türkiye’de reklam, satış, eğitim ve insan kaynakları yöneticiliği; DixonsGroup Türkiye’de İK’dan sorumlu icra kurulu üyeliği yaptı. Çalıştığı üç şirkette de şirket akademilerini kurdu ve yönetti. Stratejik yönetim, kurumsal iletişim ve insan kaynakları alanlarında üç araştırma ve beş makalesi yayımlandı. 11 yıllık oyunculuk deneyimi var; seslendirme çalışmalarını amatör olarak sürdürüyor.",
  },
  {
    key: "yaprak", img: "yaprak", name: "Yaprak Yapsan",
    role: "IDECON GRUP İLETİŞİM A.Ş. · YK BAŞKANI",
    bio: "Marmara Üniversitesi İletişim Fakültesi Gazetecilik’te başlayan eğitimini Viyana Üniversitesi’nde Halkla İlişkiler ve Siyaset Bilimi, Newcastle Üniversitesi’nde sürdürdü; USLA – Uluslararası Servis ve Lezzet Akademisi’nde profesyonel aşçılık eğitimini tamamladı.",
    more: "Kurumsal firmalarda asistanlıktan direktörlüğe uzanan kariyerinin ardından Idecon Idea&Congress’i kurdu; verilerin toplanması ve yorumlanması, teknoloji okuryazarlığı ve dijital mecraların stratejik kullanımı konularında pek çok sektörde önemli markalara ve liderlere danışmanlık veriyor. Global akreditasyon mentorluk belgesiyle eğitim, moderasyon ve konuşma programları yürütüyor. Aynı zamanda Konsensus Gıda–Bi’Zeytin markasının kurucu ortağı.",
  },
  {
    key: "mine-ataman", img: "mine-ataman", name: "Mine Ataman",
    role: "TARIM YAZARI · MARKA STRATEJİSTİ · KONUŞMACI",
    bio: "Gazi İİBF İngilizce Çalışma Ekonomisi ve Endüstri İlişkileri mezunu; arkeoloji eğitimi ve marka yönetimi yüksek lisansı var. 25 yılı aşkın süredir perakende, tarım ve gıda alanında şirketler kuruyor ve yönetiyor.",
    more: "Kamu kurumlarına, bakanlıklara, belediyelere, STK’lara ve özel şirketlere marka yönetimi, kırsal kalkınma, sürdürülebilirlik, kooperatifçilik ve tarım iletişimi alanlarında danışmanlık veriyor. Tarımda girişimcilik ve markalaşma, biyoteknoloji, tarım tarihi, Tarım 5.0 ve geleceğin gıdaları üzerine konferanslar veriyor; kongrelerde kendi tasarladığı formatlarda yeni nesil moderatörlük yapıyor. Başkent Üniversitesi ve Nişantaşı Üniversitesi Acun Medya Akademi’de ders verdi. “Ekmeğe Fısıldayan Kadın” olarak anılıyor; Cennette İlk Sofra, Şehrin En Köklüsü ve Birinci Açlık Savaşı kitaplarının yazarı.",
  },
  {
    key: "mine-rana", img: "mine-rana", name: "Av. Mine Rana Kahramanoğlu",
    role: "AVUKAT · ARABULUCU · YAZAR · MARATON KOŞUCUSU",
    bio: "25 yıllık mesleki deneyimini insan hakları, kadın ve çocuk hakları, sivil toplum ve spor alanındaki çalışmalarıyla birleştiren bir hukukçu, yazar ve konuşmacı. Marmara Üniversitesi Hukuk Fakültesi mezunu.",
    more: "Galatasaray Üniversitesi’nde Enerji Hukuku, İstanbul Medipol Üniversitesi’nde Sağlık Hukuku yüksek lisansı yaptı. 25 yıldır Bursa Barosu’na kayıtlı olarak kendi bürosunda avukatlık ve arabuluculuk yapıyor. UCİM Saadet Öğretmen Çocuk İstismarı ile Mücadele Derneği’nin Türkiye Hukuk Koordinatörü ve Türkiye Oryantiring Federasyonu Çocuk Koruma Kurulu Başkanı; Nilüfer Belediyespor Kulübü yönetim kurulu üyesi. ULUSEM’de kadın ve çocuk hakları ile insan hakları alanlarında eğitmen eğiticisi; Margarette Golding Ödülü sahibi. “Mutluluk Reçetesi: Doğal Beslenme” kitabının yazarı ve “Koşan Olimpik Anneler” koşu grubunun kurucusu.",
  },
  {
    key: "umut", img: "umut", name: "Umut Oğuz",
    role: "TİYATRO YÖNETMENİ · OYUNCU · KURUMSALHANE",
    bio: "Adanalı ve Kertenkele başta olmak üzere pek çok dizi ve filmde yer aldı; 1999’da tiyatro oyunculuğuna başladı ve pek çok tiyatroda rol aldı. Kurumsal dünyaya “Kurumsalhane” adını verdiği oluşumla adım attı.",
    more: "Markalar için komedinin baş rolde olduğu skeçler ve oyunlar hazırlayarak yıl sonu toplantıları, lansmanlar ve dönem toplantılarında yer aldı. Turkcell ile başlayan süreç Global Bilgi, Dominos, Suzuki, Hitachi, Sahibinden.com, ING Bank, Opel, Dacia, Borusan, Otokar, Doğuş Oto, Zorlu Holding ve Ülker gibi markalarla devam etti. Komedi öğeleriyle kurguladığı moderasyonla sunumları sıradanlıktan çıkarıyor.",
  },
  {
    key: "tuna", img: "tuna", name: "Tuna Arman",
    role: "OYUNCU · TELEVİZYON SUNUCUSU",
    bio: "22 Mart 1969’da İstanbul’da doğdu. 1980’de AÇOK adlı grupta tiyatroya başladı, 1982’de TES Şan Tiyatrosu kursuna gitti; 1985’te Devlet Tiyatroları’nda “Kızıldereliler” oyunuyla sahneye çıktı.",
    more: "Sadri Alışık, Abdullah Şahin ve Deve Kuşu Kabare tiyatrolarında oynadı. 2011’de engelli hayvanların varlığına dikkat çekmek için “Farkında mısın?” projesini gerçekleştirdi. Çiçek Taksi, Avrupa Yakası, Tatlı Hayat, Çocuklar Duymasın, Üç Kuruş, Bir Küçük Gün Işığı, Bahar ve Bir Gece Masalı rol aldığı yapımlar arasında.",
  },
  {
    key: "davoud", img: "davoud", name: "Seyed Davoud",
    role: "RESSAM · HEYKELTIRAŞ · YAZAR",
    bio: "1991’de İran’ın Erdebil kentinde doğan Seyed Davoud Jafar Pour Hashemi; resim, heykel ve müzik alanlarında eğitim aldı. 2018’de İran’daki ifade özgürlüğüne yönelik baskılar nedeniyle Türkiye’ye göç etti.",
    more: "Eserlerinde detaylı at yüzleri ve soyut bedenler aracılığıyla kimlik, hafıza ve varoluş gibi temaları işliyor; metin, simge ve mitoloji arasında güçlü bağlar kuruyor. İran’da ve yurt dışında birçok kişisel ve karma sergide yer aldı; eserleri sanat ve iş dünyasından pek çok tanınmış ismin koleksiyonlarında bulunuyor. UNESCO’ya bağlı IAA/AIAP’ın İran, Azerbaycan ve Suriye temsilcisidir.",
  },
];

const AVATARS = ["sinem", "sebnem", "yaprak", "ozlem", "mine-ataman", "mine-rana", "umut", "tuna", "davoud"];

function Who({ who }) {
  if (who.text) return <>{who.text}</>;
  return (
    <>
      <span className="mini" aria-hidden="true" style={who.img ? AV(who.img) : undefined}>{who.mini || ""}</span>
      <span className="wt"><b>{who.name}</b>{who.title}</span>
    </>
  );
}

export default function Landing() {
  useEffect(() => {
    const still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const target = new Date("2026-11-11T09:30:00+03:00").getTime();
    const el = { d: document.getElementById("d"), h: document.getElementById("h"), m: document.getElementById("m"), s: document.getElementById("s") };
    const pad = (n) => (n < 10 ? "0" + n : "" + n);
    const set = (node, val) => {
      if (!node || node.textContent === val) return;
      node.textContent = val;
      node.classList.remove("pop");
      void node.offsetWidth;
      node.classList.add("pop");
    };
    const tick = () => {
      let diff = target - Date.now();
      if (diff < 0) diff = 0;
      const sec = Math.floor(diff / 1000);
      set(el.d, String(Math.floor(sec / 86400)));
      set(el.h, pad(Math.floor((sec % 86400) / 3600)));
      set(el.m, pad(Math.floor((sec % 3600) / 60)));
      set(el.s, pad(sec % 60));
    };
    tick();
    const iv = setInterval(tick, 1000);

    // seamless ticker: duplicate the strip so the -100% loop never leaves a gap
    const strip = document.getElementById("tick");
    let clone = null;
    if (strip) {
      clone = strip.cloneNode(true);
      clone.removeAttribute("id");
      clone.setAttribute("aria-hidden", "true");
      strip.parentNode.appendChild(clone);
    }

    // drifting arrows across the navy bands
    const boxes = Array.from(document.querySelectorAll("[data-floaters]"));
    if (!still) {
      boxes.forEach((box) => {
        const n = parseInt(box.getAttribute("data-floaters"), 10) || 10;
        for (let i = 0; i < n; i++) {
          const s = document.createElement("span");
          s.textContent = "↑";
          const dur = 13 + Math.random() * 16;
          s.style.left = 42 + Math.random() * 58 + "%";
          s.style.fontSize = 11 + Math.random() * 16 + "px";
          s.style.animationDuration = dur + "s";
          s.style.animationDelay = -Math.random() * dur + "s";
          s.style.opacity = 0.18 + Math.random() * 0.3;
          box.appendChild(s);
        }
      });
    }

    // headings arrive word by word
    if (!still) {
      Array.prototype.forEach.call(document.querySelectorAll(".head h2"), (h2) => {
        if (h2.querySelector(".w")) return;
        const words = h2.textContent.split(" ");
        h2.textContent = "";
        words.forEach((w, i) => {
          const span = document.createElement("span");
          span.className = "w";
          span.textContent = w;
          span.style.transitionDelay = i * 0.07 + "s";
          h2.appendChild(span);
          if (i < words.length - 1) h2.appendChild(document.createTextNode(" "));
        });
      });
    }

    // cards follow the pointer a little
    const unbinders = [];
    if (!still && window.matchMedia("(hover: hover)").matches) {
      Array.prototype.forEach.call(document.querySelectorAll(".card"), (card) => {
        const mv = (e) => {
          const r = card.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          card.classList.add("tilt");
          card.style.transform = "perspective(900px) rotateX(" + -y * 6 + "deg) rotateY(" + x * 7 + "deg) translateY(-4px)";
        };
        const ml = () => { card.classList.remove("tilt"); card.style.transform = ""; };
        card.addEventListener("mousemove", mv);
        card.addEventListener("mouseleave", ml);
        unbinders.push(() => { card.removeEventListener("mousemove", mv); card.removeEventListener("mouseleave", ml); });
      });
    }

    // sections rise into view as you scroll; everything stays visible if this never runs
    let io = null;
    let fallbackT = null;
    if (!still && "IntersectionObserver" in window) {
      document.body.classList.add("anim");
      const groups = [".head", ".cols > div", ".mstats", ".closing", ".pull", ".aud article", ".aud-foot", ".row", ".card", ".opening", ".stub", ".venue", ".foot-top"];
      const items = [];
      groups.forEach((sel) => {
        Array.prototype.forEach.call(document.querySelectorAll(sel), (elm, i) => {
          elm.classList.add("reveal");
          elm.style.transitionDelay = Math.min(i, 6) * 0.06 + "s";
          items.push(elm);
        });
      });
      io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -6% 0px", threshold: 0.06 });
      items.forEach((elm) => io.observe(elm));
      fallbackT = setTimeout(() => { items.forEach((elm) => elm.classList.add("in")); }, 3000);
    }

    // scroll progress, nav highlight, program watermark drift
    const prog = document.getElementById("prog");
    const wm = document.getElementById("wm");
    const rows = Array.prototype.slice.call(document.querySelectorAll(".row"));
    const links = Array.prototype.slice.call(document.querySelectorAll(".bar nav a"));
    const sections = links.map((a) => document.querySelector(a.getAttribute("href")));
    let ticking = false;
    const frame = () => {
      ticking = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const y = window.pageYOffset || 0;
      if (prog) prog.style.width = (max > 0 ? Math.min(100, (y / max) * 100) : 0) + "%";
      if (wm && !still) {
        const r = wm.parentNode.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          wm.style.transform = "translateY(" + (window.innerHeight - r.top) * -0.06 + "px)";
        }
      }
      rows.forEach((r) => {
        r.classList.toggle("past", r.getBoundingClientRect().top < window.innerHeight * 0.62);
      });
      let current = -1;
      sections.forEach((s, i) => { if (s && s.getBoundingClientRect().top <= 140) current = i; });
      links.forEach((a, i) => a.classList.toggle("active", i === current));
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", frame, { passive: true });
    frame();

    return () => {
      clearInterval(iv);
      if (clone) clone.remove();
      boxes.forEach((b) => (b.innerHTML = ""));
      unbinders.forEach((f) => f());
      if (io) io.disconnect();
      clearTimeout(fallbackT);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", frame);
      document.body.classList.remove("anim");
    };
  }, []);

  return (
    <>
      <div className="progress" id="prog" aria-hidden="true"></div>

      <header className="bar">
        <div className="wrap">
          <a className="mark" href="#top" data-testid="nav-mark"><span className="arrow">↗</span><span className="z">Zirve</span><span className="n">11.11</span></a>
          <nav>
            <a href="#neden" data-testid="nav-link-neden">Neden?</a>
            <a href="#kimler" data-testid="nav-link-kimler">Kimler İçin</a>
            <a href="#program" data-testid="nav-link-program">Program</a>
            <a href="#konusmacilar" data-testid="nav-link-konusmacilar">Konuşmacılar</a>
            <a href="#bilet" data-testid="nav-link-bilet">Bilet</a>
          </nav>
          <a className="cta" href="#bilet" data-testid="nav-cta">Yerini ayır</a>
        </div>
      </header>

      <div className="hero" id="top">
        <div className="floaters" data-floaters="9" aria-hidden="true"></div>
        <svg className="loop a draw" viewBox="0 0 300 300" aria-hidden="true"><path d="M250 10 C 120 30, 40 110, 70 190 C 95 258, 215 255, 236 186 C 254 128, 170 96, 112 130"/></svg>
        <svg className="loop b" viewBox="0 0 300 300" aria-hidden="true"><path d="M60 290 C 30 200, 90 120, 150 150 C 205 178, 180 268, 120 262 C 70 257, 70 180, 130 150 C 190 120, 250 160, 255 220"/></svg>
        <div className="wrap">
          <div className="hero-main">
            <div className="kicker">
              <span className="chip live">11 Kasım 2026 · Çarşamba</span>
              <span className="chip"><strong>09:30 – 16:30</strong></span>
              <span className="chip">Masterpiece · Sun Plaza, Maslak</span>
            </div>

            <div className="lockup">
              <span className="arrow">↗</span>
              <div>
                <span className="word">Zirve</span>
                <span className="digits"><span className="solid">11</span><span className="hollow">11</span></span>
              </div>
            </div>

            <h1>Veriyle düşün, ilhamla tasarla, <em>insanla büyüt.</em></h1>
            <p className="lede">İş dünyasının Büyük Odaklanma Günü. Yılın en net gününde iş dünyasının karar vericileri, İK profesyonelleri ve pazarlamacılar; yapay zekânın soğuk verisini insan odaklı yaklaşımın sıcak kalbiyle, pazarlamanın yaratıcı zekâsını yöneticilerin güçlü oyun planlarıyla buluşturmak için bir araya geliyor.</p>

            <div className="hero-actions">
              <a className="btn" href="#bilet" data-testid="hero-cta-ticket"><span>Yerini ayır</span><span className="a">↗</span></a>
              <a className="btn ghost" href="#program" data-testid="hero-cta-program">Günün akışı</a>
            </div>

            <div className="count" id="count" aria-label="Zirveye kalan süre" data-testid="countdown">
              <div><b id="d">–</b><small>GÜN</small></div>
              <div><b id="h">–</b><small>SAAT</small></div>
              <div><b id="m">–</b><small>DAKİKA</small></div>
              <div><b id="s">–</b><small>SANİYE</small></div>
            </div>

            <div className="hero-logos" data-testid="hero-logos">
              <span className="hlogo"><img src={dbLogo} alt="DB Positive" /></span>
              <span className="hlogo"><img src={giftLogo} alt="Gift İstanbul" /></span>
              <span className="hlogo"><img src={ivkLogo} alt="İlham Veren Konuşmalar" /></span>
            </div>
          </div>

          <aside className="hero-side">
            <div className="cluster" aria-hidden="true">
              {AVATARS.map((v) => <span key={v} className="av" style={AV(v)}></span>)}
            </div>
            <p className="side-note"><b>9 konuşmacı</b>Finans, yapay zekâ, İK, tarım, hukuk, tiyatro ve sanat aynı sahnede.</p>
          </aside>
        </div>
      </div>

      <div className="ticker" aria-hidden="true">
        <ul id="tick">
          <li>VERİYLE DÜŞÜN</li><li>İLHAMLA TASARLA</li><li>İNSANLA BÜYÜT</li><li>BÜYÜK ODAKLANMA GÜNÜ</li><li>KENDİNE GEL, ZİRVEYE GEL</li>
        </ul>
      </div>

      <section className="manifesto" id="neden">
        <div className="wrap">
          <div className="head">
            <span className="eyebrow">MANİFESTO</span>
            <h2>11.11’in anlamını değiştiriyoruz</h2>
            <p className="sub">Yılın en net gününde, iş dünyasının geleceğini tasarlamaya davetlisiniz.</p>
          </div>
          <div className="cols">
            <div>
              <p className="first">Bugüne kadar 11.11, takvimlerde yalnızca sembolik bir tarih ya da geçici bir gündem olarak yer aldı. Bu yıl hafızaları tazeliyor ve bu özel güne yeni bir anlam kazandırıyoruz: 11 Kasım, artık iş hayatımız için en net kararları aldığımız, vizyonumuzu tazelediğimiz ve ortak geleceğimizi şekillendirdiğimiz bir “Büyük Odaklanma Günü” oluyor.</p>
              <p>İster küresel bir yapının stratejisine yön verin, ister bir patron şirketinde büyümeyi sırtlayın; ister üretim sahasında, ister yönetim merkezinde olun… İş dünyasının neresinde katma değer üretirseniz üretin, her gün büyük bir sorumluluk temposunun içinde hareket ediyorsunuz.</p>
            </div>
            <div>
              <p>Teknolojinin ve pazarların baş döndüren hızını yakalamaya çalışırken en kritik başarı faktörünü, yani insanı ve onun potansiyelini bazen arka planda bırakabiliyoruz. Zirve 11.11; tam bu koşturmacanın ortasında yönünü yeniden insana, stratejiye ve sürdürülebilir başarıya çevirmek isteyen tüm profesyonellerin ortak buluşma noktasıdır.</p>
              <p>Yapay zekânın sunduğu soğuk veriyi insan odaklı yaklaşımın sıcak kalbiyle, pazarlamanın yaratıcı zekâsını yöneticilerin güçlü oyun planlarıyla birleştiriyoruz. Değişimin hızına seyirci kalmakla yetinmiyor, o süreci yönetmenin hazzını ve bilgisini paylaşıyoruz.</p>
            </div>
            <div className="mstats">
              <div><b>09:30 → 16:30</b><span>TEK GÜN, TAM ODAK</span></div>
              <div><b>360°</b><span>PERSPEKTİF</span></div>
              <div><b>9 KONUŞMACI</b><span>SAHNEDE</span></div>
            </div>
            <p className="closing">Finansal özgürlüğün akılcı adımlarından dijital sanatın vizyoner dünyasına, yeni nesil liderlikten iş hayatının uzun maratonunda dengede kalabilmenin sınırlarına kadar 360 derecelik bir perspektif sunuyoruz. Bilginin deneyime, bağlantıların güçlü bir geleceğe dönüştüğü bu prestijli günde yeriniz hazır.</p>
            <div className="pull">
              <span className="q">“</span>
              <p>Kendine gel, zirveye gel.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="aud-band" id="kimler">
        <div className="wrap">
          <div className="head">
            <span className="eyebrow">KİMLER İÇİN</span>
            <h2>Neden 11 Kasım’da Zirve 11.11’de olmalısınız?</h2>
          </div>
          <div className="aud">
            <article data-testid="audience-1">
              <span className="tag">01</span>
              <h3>Liderler, patronlar ve karar vericiler</h3>
              <p>Değişimin hızını analiz etmek ve yeni dönemin oyun planında stratejik olarak bir adım önde olmak için.</p>
            </article>
            <article data-testid="audience-2">
              <span className="tag">02</span>
              <h3>İK profesyonelleri &amp; pazarlamacılar</h3>
              <p>Yapay zekânın sunduğu verileri yaratıcı zekâyla harmanlayarak, insanı ve markayı merkeze alan yeni nesil stratejileri keşfetmek için.</p>
            </article>
            <article data-testid="audience-3">
              <span className="tag">03</span>
              <h3>İş dünyasının tüm değer üretenleri</h3>
              <p>Finansal özgürlükten sıfır atığa, fütüristik tarımdan motivasyona uzanan güçlü bir entelektüel sermaye kazanıp; nitelikli bir networking alanı ile profesyonel ağınızı büyütmek için.</p>
            </article>
          </div>
          <div className="aud-foot">
            <p>Takviminizi netleştirin, vizyonunuzu genişletin.</p>
            <a className="btn" href="#bilet" data-testid="aud-cta"><span>Kendine gel, zirveye gel</span><span className="a">↗</span></a>
          </div>
        </div>
      </section>

      <section className="program" id="program">
        <div className="watermark" id="wm" aria-hidden="true">11.11</div>
        <div className="wrap">
          <div className="head">
            <span className="eyebrow">ETKİNLİK PROGRAMI</span>
            <h2>Bir günde tüm gündem</h2>
            <p>09:30’da kahveyle başlıyor, 16:30’da happy hour ile bitiyor. Arada finanstan agentic yapay zekâya, dijital liderlikten sıfır atık sanatına on başlık.</p>
          </div>
          <div className="rail" data-testid="program-rail">
            {RAIL.map((it, i) =>
              it.period ? (
                <div className="period" key={i}>{it.period}</div>
              ) : (
                <div key={i} className={`row ${it.cls || ""}`.trim()} data-testid={`program-row-${i}`}>
                  <div className="time">{it.time}</div><div className="dot"></div>
                  <div className="topic">{it.topic}</div>
                  <div className="who"><Who who={it.who} /></div>
                </div>
              )
            )}
          </div>
        </div>
      </section>

      <section className="spk" id="konusmacilar">
        <div className="wrap">
          <div className="head">
            <span className="eyebrow">KONUŞMACILAR</span>
            <h2>Sahnede kim var?</h2>
            <p>Veriden sanata, finanstan liderliğe; bir günde dokuz farklı bakış açısı.</p>
          </div>
          <div className="grid">
            {SPEAKERS.map((s) => (
              <article key={s.key} className={`card ${s.feature ? "feature" : ""}`.trim()} data-testid={`speaker-card-${s.key}`}>
                <div className="portrait" role="img" aria-label={s.name}><i className="ph" style={s.pos ? { ...AV(s.img), backgroundPosition: s.pos } : AV(s.img)}></i></div>
                {s.feature ? (
                  <div className="fbody">
                    <span className="feature-tag">ÖNE ÇIKAN OTURUM</span>
                    <h3>{s.name}</h3>
                    <div className="role">{s.role}</div>
                    <p>{s.bio}</p>
                    <details data-testid={`speaker-more-${s.key}`}><summary><span>DEVAMI</span></summary><p>{s.more}</p></details>
                  </div>
                ) : (
                  <>
                    <h3>{s.name}</h3>
                    <div className="role">{s.role}</div>
                    <p>{s.bio}</p>
                    <details data-testid={`speaker-more-${s.key}`}><summary><span>DEVAMI</span></summary><p>{s.more}</p></details>
                  </>
                )}
              </article>
            ))}
          </div>
          <div className="opening"><span className="mini" aria-hidden="true">DB</span><span>AÇILIŞ KONUŞMASI · <b>DERYA BABUÇ AYDIN</b> · DB POSITIVE KURUCU</span></div>
        </div>
      </section>

      <section className="ticket-band" id="bilet">
        <div className="wrap">
          <div className="stub">
            <div className="left">
              <span className="eyebrow">KATILIM BEDELİ</span>
              <div className="prices">
                <div className="opt main"><span className="k">YÜZ YÜZE KATILIM</span><span className="v">5.000 TL</span><small>KDV DAHİL</small></div>
                <div className="opt"><span className="k">ONLINE KATILIM</span><span className="v">3.000 TL</span><small>KDV DAHİL</small></div>
              </div>
              <div className="group">
                <span className="gk">GRUP<br />AVANTAJI</span>
                <span className="gv"><b>%30</b><span>indirim<br />2. kişiye</span></span>
                <span className="gv"><b>%50</b><span>indirim<br />3. kişiye</span></span>
              </div>
              <p className="scholar">Bilet geliriyle 2026–2027 öğretim yılı kapsamında üniversite öğrencilerine burs sağlanacaktır.</p>
              <a className="btn" href="mailto:info@dbpositive.com?subject=Zirve%2011.11%20Kay%C4%B1t" data-testid="ticket-cta"><span>Kayıt için yazın</span><span className="a">↗</span></a>
            </div>
            <div className="right">
              <h2>Bilete dahil</h2>
              <ul className="incl">
                <li>Zirve’ye tam gün katılım hakkı</li>
                <li>Tüm ikramlar</li>
                <li>Sürpriz etkinliklere katılım hakkı</li>
                <li>Gün boyunca sunulacak hediyeler</li>
              </ul>
              <div className="contact">
                <span className="ck">KAYIT VE BİLGİ</span>
                <a href="mailto:info@dbpositive.com" data-testid="ticket-email">info@dbpositive.com</a>
                <a href="tel:+908503093956" data-testid="ticket-phone">0850 309 39 56</a>
              </div>
            </div>
          </div>
          <div className="venue">
            <div className="logo"><img src={masterpiece} alt="Masterpiece" /></div>
            <div className="vt">
              <span className="vk">MEKÂN SPONSORU</span>
              <h3>Masterpiece</h3>
              <p>Sun Plaza, Maslak, Bilim Sk. No: 5A K:-5 · Sarıyer / İstanbul</p>
            </div>
            <a className="map" href="https://www.google.com/maps/search/?api=1&amp;query=Masterpiece+Sun+Plaza+Maslak+Sar%C4%B1yer+%C4%B0stanbul" target="_blank" rel="noopener" data-testid="venue-map">HARİTADA AÇ ↗</a>
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap">
          <div className="foot-top">
            <p className="foot-note"><b>11 Kasım 2026, Çarşamba</b><br />09:30 – 16:30<br />Masterpiece · Sun Plaza, Maslak / İstanbul</p>
            <p className="foot-note">Kayıt ve bilgi<br /><b>info@dbpositive.com</b><br /><b>0850 309 39 56</b></p>
          </div>
          <div className="wordmark" aria-hidden="true">ZİRVE <em>11.11</em></div>
          <div className="foot-bottom">
            <span>ZİRVE 11.11 · İŞ DÜNYASININ BÜYÜK ODAKLANMA GÜNÜ</span>
            <span>KENDİNE GEL, ZİRVEYE GEL</span>
          </div>
        </div>
      </footer>
    </>
  );
}
